import React from 'react';

interface SpinnerProps {
  size: number;
}

function Spinner({ size }: SpinnerProps) {
  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        background: 'rgba(13,16,23,.7)',
        backdropFilter: 'blur(2px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        borderRadius: 6,
        zIndex: 10,
      }}
    >
      <span
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          border: '3px solid rgba(255,255,255,.15)',
          borderTopColor: 'var(--gold)',
          display: 'inline-block',
          animation: 'spin 0.7s linear infinite',
        }}
      />
    </div>
  );
}

export default Spinner;
